import { ClinicList, PCPList } from '~/services';

export function markDuplicatePCPs(pcps: PCPList) {
    if (pcps === null) return [];
    const vals: { [key: string]: number[] } = {};
    pcps.forEach((x, i) => {
        if (!vals[x.label]) {
            vals[x.label] = [i];
            delete pcps[i].duplicate;
        } else {
            vals[x.label].push(i);
            vals[x.label].forEach((y) => {
                pcps[y].duplicate = true;
            });
        }
    });
    return pcps;
}

export function mapPCPs(clinics: ClinicList) {
    if (clinics === null) return [];
    return markDuplicatePCPs(
        clinics
            .map((x) => x.pcps)
            .flat()
            .sort((a, b) => (a.label > b.label ? 1 : -1))
    );
}
